<template>
    <div class="filter-item filter-item--category-filter">
        <h2 class="filter-item__heading" v-text="translations.title"></h2>
        <div class="filter-stars">
            <div class="filter-stars__item" v-for="(star, starKey) in stars" :key="starKey" @mouseout="hoverStars = -1" @mouseover="hoverStars = starKey + 1" @click="category = starKey + 1">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.99 30.39" class="filter-stars__icon" :class="{'filter-stars__icon--filled': star, 'filter-stars__icon--hover': hoverStars >= (starKey + 1)}"><path d="M31.94,11.54a1,1,0,0,0-1-.7H20.26L16.94.69a1,1,0,0,0-1.9,0L11.73,10.84H1a1,1,0,0,0-.95.7,1,1,0,0,0,.36,1.11l8.68,6.28L5.78,29.08A1,1,0,0,0,7.31,30.2L16,23.92l8.68,6.28a1,1,0,0,0,.59.19,1,1,0,0,0,.95-1.31L22.9,18.93l8.67-6.28a1,1,0,0,0,.37-1.11Z"/></svg>
            </div>
        </div>
        <p v-text="subText"></p>
    </div>
</template>

<script>
import { trackEvent } from '../../tracker';

export default {
    data() {
        return {
            translations: APP_CONFIG.TRANSLATION.CATEGORY_FILTER,
            category: 1,
            hoverStars: -1
        }
    },
    mounted() {
        this.category = this.$route.query.minHotelCategory || 1;
    },
    watch: {
        category() {
            let query = Object.assign({}, this.$route.query);
            query.minHotelCategory = this.category;
            this.$router.replace({query}, (to, from, next) => {
                trackEvent({
                    event: 'Filter - Hotel Stjerner',
                    target: to.fullPath,
                    value: this.category,
                    destination: (this.$store) ? this.$store.state.destination : null,
                    'interaction-type': 'noninteraction',
                })
            });
        },
        '$route.query.minHotelCategory'() {
            if(this.$route.query.minHotelCategory != this.category) {
                let minHotelCategory = this.$route.query.minHotelCategory;
                this.category = (!minHotelCategory) ? 1 : minHotelCategory;
            }
        }
    },
    computed: {
        subText() {
            let starText = this.category + ' ';
            starText += (this.category <= 1) ? this.translations.star_single : this.translations.star_multiple;

            return this.translations.subtext.replace(/{stars}/, starText);
        },
        stars() {
            let stars = [ ];
            for(let i = 1; i<=5; i++) {
                if(this.category >= i) {
                    stars.push(true);
                } else {
                    stars.push(false);
                }
            }

            return stars;
        }
    }
}
</script>
